export default {
    meta: {
        title: '展位资源分类',
        isShowNav: true,
    },
};
